export enum Status {
  Open = 'Open',
  Closed = 'Closed',
  All = 'All'
}

export type StatusType = keyof typeof Status;
